import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'any'
})
export class PingService {
  private http = inject(HttpClient);

  private URL = `${environment.RH_BASE_URL}/mgmt/users`;

  // if authentication is expired or wrong, the http interception
  // will invalidate the session
  public ping(userId: string): Observable<boolean> {
    return this.http
      .get<Observable<HttpResponse<boolean>>>(`${this.URL}/${userId}`, {
        observe: 'response',
      })
      .pipe(map((resp: HttpResponse<any>) => resp.status === 200));
  }
}
